import { ReactNode, useMemo } from 'react';

import { DepartmentPageLayout } from '@/components/DepartmentPageLayout';
import { PageContent } from '@/components/PageContent';
import { PhotoVideoRecording } from '@/components/sections/PhotoVideoRecording';
import { Rules } from '@/components/sections/Rules';
import { DepartmentPageSlug, IPage } from '@/types';

const pageContent: Record<string, ReactNode> = {
  'photo-and-video-recording': <PhotoVideoRecording />,
  'rules-of-conduct': <Rules />,
};

interface IUsePageContent {
  ContentComponent: ReactNode;
}

export const usePageContent = (pageDetails: IPage | undefined): IUsePageContent => {
  const ContentComponent = useMemo<ReactNode>(() => {
    if (!pageDetails) {
      return null;
    }

    const { slug, page_body } = pageDetails;

    if (slug?.startsWith('department')) {
      return <DepartmentPageLayout slug={slug as DepartmentPageSlug} />;
    }

    return pageContent[slug] ?? <PageContent pageBody={page_body ?? ''} />;
  }, [pageDetails]);

  return { ContentComponent };
};
